angular.module('pe4h').run(['$templateCache', function($templateCache) {
  $templateCache.put('components/projects/viewProjects.html',
    '<update-title title="Contract Engineering Jobs | Submit Your Proposal | PEforHire.com"></update-title>\n' +
    '<update-meta name="description" content="View a list of current Engineering projects. When you see a project that you’re interested in bidding on, submit a proposal for a small fee. Sign up today and your first proposal is FREE!"></update-meta>\n' +
    '<section id="viewProjects" class="content dashboard public">\n' +
    '    <div class="container">\n' +
    '\n' +
    '        <div class="row">\n' +
    '            <div class="col-sm-6 col-lg-8">\n' +
    '                <h1>{{projectsTitle || "Projects"}}</h1>\n' +
    '            </div>\n' +
    '            <div class="col-sm-6 col-lg-4 filters">\n' +
    '                <form>\n' +
    '                    <ul class="list-inline form-filters">\n' +
    '                        <li class="form-group hidden-xs hidden-sm">\n' +
    '                            <h5>Filter</h5>\n' +
    '                        </li>\n' +
    '                        <li class="form-group filter-a">\n' +
    '                            <label class="select input-type">\n' +
    '                                <select ng-change="onLicenseStateChange()" ng-options="l.Label disable when !l.Available for l in projectLicenses" ng-model="projectFilters.license"\n' +
    '                                 class="form-control input-lg">\n' +
    '                                    <option value="">Licenses (All)</option>\n' +
    '                                </select>\n' +
    '                            </label>\n' +
    '                        </li>\n' +
    '                        <li class="form-group filter-b">\n' +
    '                            <label class="select input-type">\n' +
    '                                <select ng-change="onLicenseStateChange()" ng-options="s.Label disable when !s.Available for s in projectStates" ng-model="projectFilters.state"\n' +
    '                                 class="form-control input-lg">\n' +
    '                                    <option value="">States (All)</option>\n' +
    '                                </select>\n' +
    '                            </label>\n' +
    '                        </li>\n' +
    '                    </ul>\n' +
    '                </form>\n' +
    '            </div>\n' +
    '        </div>\n' +
    '        <div id="welcome" ng-cloak class="dashboard-box" ng-show="!loadingPublicProjects && projects.length == 0">\n' +
    '			<a class="pull-right close" onclick="document.getElementById(\'welcome\').className=\'hidden\';"></a>\n' +
    '			<h2 class="welcome">No Results</h2>\n' +
    '			<div class="row">\n' +
    '				<div class="col-sm-8 welcome">\n' +
    '					<p>There are no Projects meeting your search criteria. Try widening the search.</p>\n' +
    '				</div>\n' +
    '			</div>\n' +
    '		</div>\n' +
    '\n' +
    '        <div id="gallery-wrap" custom-scroll on-scroll="onScroll">\n' +
    '            <ul class="dynamic-grid" angular-grid="projects" ag-grid-width="280" ag-gutter-size="20" ag-id="gallery" performantScroll="true"\n' +
    '                scroll-container="#gallery-wrap" ag-infinite-scroll="getMoreProjects()" infinite-scroll-distance="1" refresh-on-img-load="false" style="width:100%">\n' +
    '                <li data-ng-repeat="project in projects track by $index" class="grid card">\n' +
    '                    <div>\n' +
    '                        <div class="project-closed" ng-if="project.Status == \'closed\' || project.Status == \'hired\'"></div>\n' +
    '                        <div class="map" ng-show="project.latlng">\n' +
    '                            <img class="h-100 w-100" ng-src="{{\'https://maps.googleapis.com/maps/api/staticmap?zoom=7&size=366x200&maptype=roadmap\n' +
    '                            &markers=icon:\'+assetsUrl+\'assets/icons/marker.png%7C\'+project.latlng.lat+\',\'+project.latlng.lng+\'\n' +
    '                            &key=AIzaSyBhUA7ChLHXS1g5AT1kUbHUoVIQzEvM89w\'}}">\n' +
    '                            </img>\n' +
    '                        </div>\n' +
    '                        <section class="project-engineer">\n' +
    '                            <a target="_blank" ng-if="project.Attachment" ng-href={{project.Attachment.Url}} class="project-doc fa fa-file-image-o download-pdf"\n' +
    '                                uib-tooltip="View Attachment">\n' +
    '                            </a>\n' +
    '                            <h4>\n' +
    '                                <a href="" ui-sref="project({uid:project.UID, projectTitle:generateSEOTitleForProject(project)})">{{project.LicenseLabel}}</a>\n' +
    '                                <small>{{project.City}}, {{project.StateLicense}}</small>\n' +
    '                            </h4>\n' +
    '                            <h5>\n' +
    '                                {{project.Title}}\n' +
    '                            </h5>\n' +
    '                            <p class="project-teaser">\n' +
    '                                {{project.Description | trimText:true:100:\' ...\'}}\n' +
    '                            </p>\n' +
    '                            <p class="project-date">\n' +
    '                                <span class="text-muted">Posted</span>{{project.CreatedDate | localeDateHuman}}\n' +
    '                            </p>\n' +
    '                            <a ng-if="project.Status != \'closed\' && project.Status != \'hired\'" href="" ui-sref="project({uid:project.UID, projectTitle:generateSEOTitleForProject(project)})" class="btn btn-primary mt20">View</a>\n' +
    '                        </section>\n' +
    '                    </div>\n' +
    '                </li>\n' +
    '            </ul>\n' +
    '        </div>\n' +
    '    </div>\n' +
    '    <!-- Load more -->\n' +
    '    <div class="load-cards" ng-show="loading">\n' +
    '        <a href="javascript:;" class="fa fa-refresh fa-spin"></a>\n' +
    '    </div>\n' +
    '</section>');
}]);
